import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import Style from './ForumQuestionList.module.css'
const ForumQuestionList = ({data,serachText}) => {
    return (
        <ul className='pageHolder' style={{padding:0}}>
            {data.slice(0).reverse().filter(value=>{
                if(value.question.includes(serachText)){
                    return value
                }
                else if(serachText===''){
                    return value
                }
            }).map((item,index)=>{
                return(
                    <li key={item.id} className={Style.EachQ}>
                        <p><span>{index+1}_</span>{item.question}</p>
                        <Link to={{pathname:`/forum/question/${item.id}`,state:item}}>دیدن پاسخ ها <FontAwesomeIcon icon={faChevronLeft}/></Link>
                    </li>
                )
            })}

        </ul>
    )
}

export default ForumQuestionList
